import * as React from "react";
export class ScoreRowCells extends React.PureComponent {
    render() {
        return (this.props.displayedInnings.map((displayedInning, index) => {
            let score = (this.props.scores.length > index && this.props.scores[index] !== undefined)
                ? this.props.scores[index] : "-";
            return (React.createElement("td", { className: "rj-baseball-scoreboard-score-cell", key: `${this.props.rowCellkey}-inning-${index}` }, score));
        }));
    }
}
//# sourceMappingURL=ScoreRowCells.js.map